import { NodeViewProps, useEditorState } from '@tiptap/react';

import FormFieldCard from './FormFieldCard';
import FormFieldReadView from './FormFieldReadView';

const FormFieldView = (props: NodeViewProps) => {
  const isEditable = useEditorState({ editor: props.editor, selector: ({ editor }) => editor.isEditable });
  return isEditable ? <FormFieldCard {...props} /> : <FormFieldReadView {...props} />;
};

export default FormFieldView;
